import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { CarouselComponent, CarouselService } from '@spartacus/storefront';
import { Subscription, interval } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';

@Component({
    selector: 'app-uig-carousel',
    templateUrl: './uig-carousel.component.html',
    standalone: false
})
export class UigCarouselComponent extends CarouselComponent implements OnInit, OnDestroy {

  subscription = new Subscription();

  @Input() timeout: number | undefined | null = 10;

  constructor(protected el: ElementRef, protected service: CarouselService, protected ref: ChangeDetectorRef) {
    super(el, service);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.subscription = this.size$
      .pipe(
        take(1),
        switchMap((size) =>
          interval(this.timeout * 1000).pipe(
            tap(() => {
              this.activeSlide =
                this.activeSlide > this.items.length - size - 1
                  ? 0
                  : this.activeSlide + size;
              this.ref.markForCheck();
            })
          )
        )
      )
      .subscribe();
  }

  ngOnDestroy() { 
    this.subscription.unsubscribe(); 
  }

}
